<div class="card mt-4">
  <h4 class="card-header card-title">{{ settings.title || 'Analytics Table' }}</h4>
  <div class="card-body">
    <div *ngIf="settings.subtitle">{{ settings.subtitle }}</div>
    <div>{{ formatDuration() }}</div>
    <h2 *ngIf="error" class="text-danger">Error</h2>
    <h2 *ngIf="!error && !values" class="spinner-border spinner-border-lg"></h2>
    <table *ngIf="!error && values" class="table table-striped">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" *ngFor="let col of columnHeaders">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rowHeaders">
          <th scope="row">{{ row }}</th>
          <td scope="row" *ngFor="let col of columnHeaders">
            {{ stats.formatMetric(settings.metric, values[col][row], settings.relative) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
